
<div class="container pt-3">
    <div class="row justify-content-sm-center">
        
      <div class="col-sm-6 col-md-4">
          <br>
          <div class="logo-text" >friggkantine<span class="copyrights">®</span></div>
          <!-- <img src="assets/img/henther.svg" width="355"> -->
          <br><br>
          <div class="alert alert-danger" *ngIf= "error">
            <strong>Error:</strong> {{error['message']}}
          </div>
        <div class="card border-info text-center">
          <div class="card-header header-color">
            Reset password
          </div>
          <div class="card-body">
            <!-- <img src="https://placeimg.com/128/128/tech/sepia"> -->
            
            <form 
              class="form-signin" 
              (ngSubmit)="onSignin(f)" 
              #f="ngForm">
              <input 
                type="email" 
                class="form-control mb-2" 
                placeholder="Email" 
                id="email" 
                name="email" 
                ngModel 
                #email="ngModel" 
                email 
                required 
                autofocus
              ><br>
              <button 
                class="btn btn-lg button btn-block mb-1 " [class.green-button]="valid(f)"
                type="submit">
                Send
              </button>
              <a [routerLink]="['/signin']"  class="float-right">
                Back to login
              </a>
            </form>
          </div>
        </div>
        
        <!-- <a href="#" class="float-right">Create an account </a> -->
      </div>
    </div>
  </div>
  